<template>
  <v-row>
    <v-dialog v-model="visible" persistent max-width="600">
      <v-card class="btn-custom">
        <v-card-text class="mt-10">
          <p class="text-lg">
            {{ title }}
          </p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="darken-1"
            text
            large
            style="font-size: 16px"
            @click="onCancel"
          >
            Huỷ
          </v-btn>
          <v-btn
            color="#FBB040"
            text
            large
            style="font-size: 16px"
            @click="onConfirm"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { EMPTY } from "~/utils/constants";

export default {
  name: "AppModal",

  props: {},

  data() {
    return {
      visible: false,
      title: EMPTY,
      callbackConfirm: {},
    };
  },

  beforeMount() {
    this.$eventBus.$on("show-modal", (params) => {
      this.show(params);
    });
  },

  methods: {
    show(params) {
      console.log("🚀 ~ file: AppModal.vue:61 ~ show ~ params", params)
      const { visible, title, callbackConfirm } = params;
      this.visible = visible;
      this.title = title;
      this.callbackConfirm = callbackConfirm;
    },
    hide() {
      this.visible = false;
    },
    onCancel() {
      this.hide();
    },
    onConfirm() {
      this.hide();
      if (typeof this.callbackConfirm === "function") {
        this.callbackConfirm();
        (this.title = EMPTY), (this.callbackConfirm = {});
      }
    },
  },
};
</script>
